<!-- 创建城市运营券模券模板接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCodeList" : ["PRJ9YJ19"],
                "couponTemplate" : {
                    "wxAppid" : "wx4965abff0ba79af7",
                    "name" : "抵扣1元券",
                    "totalNum" : 2,
                    "couponType" : 1,
                    "faceValue" : 1,
                    "useRuleFrom" : 0,
                    "useRuleTo" : 999,
                    "isCover" : 0,
                    "maxCoverNum" : 0,
                    "validFrom" : "2019-04-28 00:00:00",
                    "validTo" : "2020-04-28 00:00:00",
                    "validTime" : 360,
                    "billUseType" : 0
                }
            },
            responseCode: {
                "data": {
                    "couponTemplateCode": "8S2ZYW0WN4OC"
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台创建城市运营券模板",
                t_url: this.commonUrls.test+"createCityOperationCouponTemplate",
                p_url: this.commonUrls.prod+"createCityOperationCouponTemplate",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCodeList', info2: '是', info3: 'String[]', info4: '券适用的停车场列表' },
                        { info1: 'couponTemplate', info2: '是', info3: 'JSONObject', info4: '券模板' },
						{ info1: 'coverUrl', info2: '否', info3: 'String', info4: '封面URL' },
						{ info1: 'logoUrl', info2: '否', info3: 'String', info4: 'LOGO_URL' }
						]
                },{
                    titleName: 'couponTemplate',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'wxAppid', info2: '是', info3: 'String', info4: '所属微信公众号appid' },
                        { info1: 'name', info2: '是', info3: 'String', info4: '券名称' },
                        { info1: 'totalNum', info2: '是', info3: 'Integer', info4: '可发放券的数量, 0代表无限张' },
                        { info1: 'couponType', info2: '是', info3: 'Integer', info4: '券类型 0:免费券,1:金额扣减券,车费减免固定金额结算,2:金额折扣券,车费折扣减免结算,3:金额固定值券,车费按券的固定值结算,4:时间券,时间减免后再按车费结算' },
                        { info1: 'faceValue', info2: '是', info3: 'Decimal', info4: '面值，免费券:默认0，金额扣减券:为大于0的正数且保留2位小数，金额折扣券:为0-1且保留2位小数，金额固定券:为大于0的正数且保留2位小数，时间券:为大于0的整数，说明:金额相关的券都以元为单位，时间券以分为单位' },
                        { info1: 'useRuleFrom', info2: '是', info3: 'Decimal', info4: '使用规则, 车费金额最小值' },
                        { info1: 'useRuleTo', info2: '是', info3: 'Decimal', info4: '使用规则, 车费金额最大值' },
                        { info1: 'couponRule', info2: '否', info3: 'Integer', info4: '扣减类型: 0 扣减前面时间，1 扣减后面时间，2 扣减进场时间和优惠时间计算的金额，3 扣减优惠时间和计费结束时间计算的金额'},
                        { info1: 'useParkingFee', info2: '否', info3: 'Integer', info4: '时间券, 扣减类型为0和1的, 需要设置优惠后是否有免费时长: 0 不使用免费时长，1 使用免费时长' },
                        { info1: 'isCover', info2: '是', info3: 'Integer', info4: '是否可叠加使用' },
                        { info1: 'maxCoverNum', info2: '是', info3: 'Integer', info4: '最大叠加数' },
                        { info1: 'validFrom', info2: '是', info3: 'String', info4: '券可发放的开始时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'validTo', info2: '是', info3: 'String', info4: '券可发放的结束时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'validTime', info2: '是', info3: 'Integer', info4: '发券后券的有效时间（单位: 分钟）' },
                        { info1: 'billUseType', info2: '是', info3: 'String', info4: '适用业务类型 0: PARKING停车费, 1: MONTH_TICKET月票，多种类型逗号分隔 如0,1' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '券备注' },
                        { info1: 'isSingleValid', info2: '否', info3: 'Integer', info4: '是否单次停车有效 默认否，0否，1是' }
                        ]
                },{
                    titleName: '扣减规则说明',
                    tabledata: [{ tableHead: '扣减规则', tdName: 'info1' }, { tableHead: '优惠后有无免费时长', tdName: 'info2' }, { tableHead: '计费说明', tdName: 'info3' }],
                    td: [
                        { info1: '扣减前面时间', info2: '有', info3: '默认；优惠后金额：将进场时间往后推时间券面值得到新计费起始时间，新计费起始时间和计费结束时间按计费规则计费得到优惠后金额；优惠金额：正常计费金额-优惠后金额', info4: '' },
                        { info1: '扣减前面时间', info2: '无', info3: '优惠后金额：将进场时间往后推时间券面值得到新计费起始时间，新计费起始时间和计费结束时间按去掉免费时长的计费规则计费得到优惠后金额；优惠金额：正常计费金额-优惠后金额', info4: '' },
                        { info1: '扣减后面时间', info2: '有', info3: '优惠后金额：将计费结束时间往前推时间券面值得到新计费结束时间，进场时间和新计费结束时间按计费规则计费得到优惠后金额；优惠金额：正常计费金额-优惠后金额', info4: '' },
                        { info1: '扣减后面时间', info2: '无', info3: '优惠后金额：将计费结束时间往前推时间券面值得到新计费结束时间，进场时间和新计费结束时间按去掉免费时长的计费规则计费得到优惠后金额；优惠金额：正常计费金额-优惠后金额', info4: '' },
                        { info1: '扣减进场时间和优惠时间计算的金额', info2: '无', info3: '优惠金额：进场时间和计费结束时间（进场时间+优惠券面值）按计费规则计算得到优惠金额；优惠后金额：正常计费金额-优惠金额', info4: '' },
                        { info1: '扣减优惠时间和计费结束时间计算的金额', info2: '无', info3: '优惠金额：计费起始时间（计费结束时间-优惠券面值）和计费结束时间按计费规则计算得到优惠金额；优惠后金额：正常计费金额-优惠金额', info4: '' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponTemplateCode', info2: '是', info3: 'String', info4: '券模版编码' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/cityOperationCoupon/createCityOperationCouponTemplate.vue